// Azzurro vocabulary expansion — BODY & HEALTH theme (net-new cards).
//
// Extends the `body-health` blocks in ./vocabulary.js without reusing any
// headword already defined there. Seed upserts on `spanish`, so every value is
// unique.
//   [ italian, english, emoji, part_of_speech, gender, example_it, example_en ]

export const VOCAB_BODY_HEALTH = [
  {
    theme: "body-health", tier: "A1", rows: [
      ["l'orecchio", "ear", "👂", "noun", "m", "Mi fa male l'orecchio sinistro.", "My left ear hurts."],
      ["il dente", "tooth", "🦷", "noun", "m", "Mi lavo i denti dopo i pasti.", "I brush my teeth after eating."],
      ["il dito", "finger", "🫰", "noun", "m", "Mi sono tagliato il dito.", "I've cut my finger."],
      ["la schiena", "back", "🧍", "noun", "f", "Mi fa male la schiena di notte.", "My back hurts at night."],
      ["il collo", "neck", "🧣", "noun", "m", "Ho il collo rigido.", "My neck is stiff."],
      ["il ginocchio", "knee", "🦵", "noun", "m", "Mi sono fatto male al ginocchio.", "I hurt my knee."],
      ["il cuore", "heart", "❤️", "noun", "m", "Il cuore batte molto velocemente.", "The heart beats very fast."],
      ["lo stomaco", "stomach", "🤰", "noun", "m", "Mi fa male lo stomaco.", "My stomach hurts."],
      ["la gola", "throat", "🗣️", "noun", "f", "Ho la gola irritata.", "My throat is sore."],
      ["la spalla", "shoulder", "💪", "noun", "f", "Porto lo zaino su una spalla.", "I carry the backpack on one shoulder."],
    ],
  },
  {
    theme: "body-health", tier: "A2", rows: [
      ["il raffreddore", "cold (illness)", "🤧", "noun", "m", "Ho un forte raffreddore.", "I have a bad cold."],
      ["l'influenza", "flu", "🌡️", "noun", "f", "È a letto con l'influenza.", "She's in bed with the flu."],
      ["la tosse", "cough", "😷", "noun", "f", "La tosse non mi fa dormire.", "The cough won't let me sleep."],
      ["la benda", "bandage", "🩹", "noun", "f", "Il medico mi ha messo una benda.", "The doctor put a bandage on me."],
      ["il cerotto", "plaster / band-aid", "🩹", "noun", "m", "Mi serve un cerotto per il dito.", "I need a plaster for my finger."],
      ["lo sciroppo", "syrup (medicine)", "🍶", "noun", "m", "Prendi lo sciroppo per la tosse.", "Take the cough syrup."],
      ["l'ambulatorio", "doctor's office / appointment", "🏥", "noun", "m", "L'ambulatorio apre alle nove.", "The surgery opens at nine."],
      ["fare male", "to hurt", "😣", "verb", "", "Mi fa male tutto il corpo.", "My whole body aches."],
      ["ingrassare", "to put on weight", "⚖️", "verb", "", "Sono ingrassato di due chili.", "I've put on two kilos."],
      ["dimagrire", "to lose weight", "📉", "verb", "", "Vuole dimagrire per l'estate.", "She wants to lose weight for the summer."],
    ],
  },
  {
    theme: "body-health", tier: "B1", rows: [
      ["il malessere", "discomfort / unwellness", "😖", "noun", "m", "Sento un malessere generale.", "I feel a general unwellness."],
      ["la diagnosi", "diagnosis", "🩺", "noun", "f", "La diagnosi ha richiesto una settimana.", "The diagnosis took a week."],
      ["il disturbo", "ailment", "🤕", "noun", "m", "È un disturbo cronico ma lieve.", "It's a chronic but mild ailment."],
      ["cronico", "chronic", "♾️", "adjective", "", "Soffre di mal di schiena cronico.", "He suffers from chronic back pain."],
      ["acuto", "acute / sharp", "⚡", "adjective", "", "Ha sentito un dolore acuto al petto.", "He felt a sharp pain in his chest."],
      ["il ricovero", "hospital admission", "🛏️", "noun", "m", "Il ricovero è stato d'urgenza.", "The admission was an emergency."],
      ["il congedo per malattia", "sick leave", "📋", "phrase", "", "È in congedo per malattia per due settimane.", "She's on sick leave for two weeks."],
      ["svenire", "to faint", "😵", "verb", "", "È svenuto per il caldo.", "He fainted from the heat."],
      ["la cicatrice", "scar", "➰", "noun", "f", "Gli è rimasta una piccola cicatrice.", "He was left with a small scar."],
      ["alleviare", "to relieve", "🌿", "verb", "", "La pastiglia allevia subito il dolore.", "The pill relieves the pain right away."],
    ],
  },
];
